import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BreakpointObserver } from '@angular/cdk/layout';
import { LocalStorageService } from 'ngx-webstorage';
import { CreateService } from '../services/create.service';
import { AssignSharedFolderComponent } from '../dialog/assign-shared-folder/assign-shared-folder.component';
import { MatDialog } from '@angular/material/dialog';
import { UploadDialogComponent } from '../folder-listings-page/upload-dialog/upload-dialog.component';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  isMobile: boolean = false;
  userEmailId = this.storage.retrieve("userEmailId");
  allSharedDrives: any = [];
  allSharedDrivesFiltered: any = [];
  gridView: boolean = false;
  listView: boolean = true;
  ascSorted: boolean = false;
  descSorted: boolean = true;
  isUserAuthorizedToUploadTemplate: boolean = false;


  constructor(public router: Router,
    breakpointObserver: BreakpointObserver,
    private storage: LocalStorageService,
    private createService: CreateService,
    private dialog: MatDialog) {
    breakpointObserver.observe([
      '(max-width: 767px)'
    ]).subscribe((result: { matches: boolean; }) => {
      this.isMobile = result.matches;
    });
  }

  ngOnInit() {
    this.createService.listAllDrives(this.userEmailId).subscribe({
      next: (data: any) => {
        this.allSharedDrives = data;
        this.allSharedDrivesFiltered = this.allSharedDrives;
      },
      error: (e: any) => {

      }
    });

    this.createService.checkUserAccessForUploadTemplate(this.userEmailId).subscribe({
      next: (data: any) => {
        console.log(data, typeof (data))
        this.isUserAuthorizedToUploadTemplate = data;
      },
      error: (e: any) => {

      }
    });
  }

  openDrive(drive: any) {
    console.log(drive);
    this.createService.setParentId(drive);
    this.router.navigate(['folder-listings']);
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.allSharedDrivesFiltered = this.allSharedDrives.filter((aL: any) => aL.name.toLowerCase().includes(filterValue.toLowerCase()));
  }

  sortNamesAsc() {
    this.allSharedDrivesFiltered.sort((a: any, b: any) => (a.name.trim() > b.name.trim()) ? 1 : ((b.name.trim() > a.name.trim()) ? -1 : 0))
    this.ascSorted = true;
    this.descSorted = false;
  }

  sortNamesDesc() {
    this.allSharedDrivesFiltered.sort((a: any, b: any) => (b.name.trim() > a.name.trim()) ? 1 : ((a.name.trim() > b.name.trim()) ? -1 : 0))
    this.descSorted = true;
    this.ascSorted = false;
  }

  openSharedAccessDialog() {
    const dialogRef = this.dialog.open(AssignSharedFolderComponent,);
  }

  downloadUserAccessTemplate() {
    this.createService.downloadUserAccessTemplateFromServer();
  }

  uploadUserAccessTemplate() {
    const dialogRef = this.dialog.open(UploadDialogComponent, {
      data: { isUserAccessTemplate: true, type: 'file' }
    });
  }


  setViewStatus(status: string) {
    localStorage.setItem('viewStatus', status);
  }

  get isStatusGrid() {
    const status = localStorage.getItem('viewStatus') || 'list';
    return status === 'list' ? false : true
  }

}
